import BaseAPIService from "./BaseAPIService";
import gql from "graphql-tag";

export default class EventService extends BaseAPIService {
  constructor() {
    super();
  }

  getEvent(id) {
    return new Promise((resolve, reject) => {
      const query = require("../graphql/queries/event.gql");
      const variables = { id };
      this.query({ query, variables, fetchPolicy: "network-only" })
        .then((result) => {
          const returnData = result.data.event;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  createEvent(input) {
    return new Promise((resolve, reject) => {
      if (input.position && input.position.latitude) {
        input.position.latitude = parseFloat(input.position.latitude);
      }

      if (input.position && input.position.longitude) {
        input.position.longitude = parseFloat(input.position.longitude);
      }

      delete input.id;

      const mutation = gql`
        mutation createEvent($input: EventInput!) {
          createEvent(input: $input) {
            id
          }
        }
      `;
      const variables = { input };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.createEvent;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  updateEvent(input) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation updateEvent($id: ID!, $input: EventInput!) {
          updateEvent(id: $id, input: $input) {
            id
          }
        }
      `;
      const id = input.id;
      delete input.id;
      const variables = {
        id,
        input,
      };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.updateEvent;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  deleteEvent(id) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation deleteEvent($id: ID!) {
          deleteEvent(id: $id)
        }
      `;
      const variables = { id };
      this.mutate({ mutation, variables })
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  }
}
